interface ErrorLike {
  message?: unknown;
  response?: {
    data?: {
      message?: unknown;
    };
  };
}

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (typeof error !== 'object' || error === null) {
    return fallback;
  }

  const errorLike = error as ErrorLike;
  const responseMessage = errorLike.response?.data?.message;

  if (typeof responseMessage === 'string' && responseMessage.trim()) {
    return responseMessage;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof errorLike.message === 'string' && errorLike.message.trim()) {
    return errorLike.message;
  }

  return fallback;
};
